'use client';

import React from 'react';
import Image from 'next/image';

const HeroSection = ({ page, heading, description, backgroundImage }) => {
  return (
    <section
      className="relative w-full h-[55vh] bg-cover bg-center bg-no-repeat flex items-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#002F4A] to-transparent" />

      {/* Text Content */}
      <div className="relative z-10 max-w-6xl pt-12 px-4 lg:px-24 text-white">
        {/* Optional Page Label */}
        {/* <p className="text-[18px] font-medium mb-2">{page}</p> */}
        <h1 className="text-[28px] sm:text-[32px] md:text-[50px] font-bold leading-tight max-w-3xl">
          {heading}
        </h1>
        <p className="mt-4 text-[14px] max-w-2xl">
          {description}
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
